import { getTodayDate } from "../utils/date";
import { Action, UI_DAY_CHANGE } from "../actions";

export const currentDayReducer = (
    state: string = getTodayDate(),
    action: Action,
): string => {
    switch (action.type) {
        case UI_DAY_CHANGE:
            return action.payload.date;
        default:
            return state;
    }
};
